const TYPES = {
  Change: "@Theme/Change",
};

const INITIAL_STATE = {};

export default function reducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case TYPES.Change:
      return {
        ...payload,
      };
    default:
      return state;
  }
}

export function ChangeTheme(payload) {
  return {
    type: TYPES.Change,
    payload,
  };
}
